/*
 * Copyright (c) 2022. Nedaware SL
 */

import {environment} from '../../environments/environment';

export abstract class ApiInterface {
    public static readonly URL = new URL(environment.apiUrl);
    /** Roles de la API */
    public static readonly ROLES = {
        USER: 'ROLE_USUARIO',
        EMPLEADO: 'ROLE_EMPLEADO',
        ADMIN: 'ROLE_ADMIN',
        COMERCIAL: 'ROLE_COMERCIAL'
    };
    /** Rol por defecto de todos los usuarios */
    public static readonly DEFAULT_ROLE = ApiInterface.ROLES.USER;
}
